export const usaUniversities = {
  "mit": {
    slug: "mit", country: "usa",
    name: "Massachusetts Institute of Technology", shortName: "MIT", flag: "🇺🇸",
    city: "Cambridge, Massachusetts", founded: 1861, qsRank: "#1 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's #1 university and the global epicenter of science, technology, and engineering innovation. MIT has produced 97 Nobel laureates and is responsible for technologies that power the modern world — from the internet to GPS. Located in Cambridge, steps from Harvard and the Boston biotech corridor.",
    tuition: { domestic: "$57,590/yr", international: "$57,590/yr" },
    living: "$2,200–$3,200/mo", ielts: "Not required (TOEFL 90+)", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science & Artificial Intelligence", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering & Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — MIT Sloan School of Management", duration: "2 years", language: "English" },
      { name: "MS Robotics", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "98%", avgSalary: "$110,000–$180,000", topEmployers: ["Google", "Apple", "McKinsey", "SpaceX", "Goldman Sachs"] },
    intakes: ["September"], istpStudents: 15,
  },

  "stanford-university": {
    slug: "stanford-university", country: "usa",
    name: "Stanford University", shortName: "Stanford", flag: "🇺🇸",
    city: "Stanford, California", founded: 1885, qsRank: "#3 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The heartbeat of Silicon Valley. Stanford has spun off Google, HP, Netflix, and thousands of other companies. With $37 billion in endowment and the world's most powerful alumni network, Stanford is the launchpad for entrepreneurs, engineers, and leaders who shape technology and society.",
    tuition: { domestic: "$61,731/yr", international: "$61,731/yr" },
    living: "$2,400–$3,500/mo", ielts: "Not required (TOEFL 89+)", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "1–2 years", language: "English" },
      { name: "MBA — Stanford GSB", duration: "2 years", language: "English" },
      { name: "MS Artificial Intelligence", duration: "1–2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "1–2 years", language: "English" },
      { name: "MS Management Science & Engineering", duration: "1–2 years", language: "English" },
    ],
    placementStats: { rate: "98%", avgSalary: "$115,000–$185,000", topEmployers: ["Google", "Meta", "Apple", "Sequoia Capital", "McKinsey"] },
    intakes: ["September"], istpStudents: 12,
  },

  "harvard-university": {
    slug: "harvard-university", country: "usa",
    name: "Harvard University", shortName: "Harvard", flag: "🇺🇸",
    city: "Cambridge, Massachusetts", founded: 1636, qsRank: "#4 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1559135197-8a45ea74d367?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's oldest university and the most prestigious institution on earth. With $53 billion in endowment — the world's largest — Harvard's influence extends across law, medicine, government, and business. Eight U.S. presidents and 161 Nobel laureates count themselves as Harvard alumni.",
    tuition: { domestic: "$57,261/yr", international: "$57,261/yr" },
    living: "$2,200–$3,200/mo", ielts: "Not required (TOEFL 80+)", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Harvard Business School", duration: "2 years", language: "English" },
      { name: "JD — Harvard Law School", duration: "3 years", language: "English" },
      { name: "MD — Harvard Medical School", duration: "4 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MPP — Harvard Kennedy School", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "98%", avgSalary: "$115,000–$200,000", topEmployers: ["McKinsey", "Goldman Sachs", "Google", "U.S. Government", "Bain & Company"] },
    intakes: ["September"], istpStudents: 10,
  },

  "caltech": {
    slug: "caltech", country: "usa",
    name: "California Institute of Technology", shortName: "Caltech", flag: "🇺🇸",
    city: "Pasadena, California", founded: 1891, qsRank: "#6 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's most elite STEM university per student — with 47 Nobel laureates from a tiny campus. Caltech manages NASA's Jet Propulsion Laboratory and is the birthplace of earthquake engineering and modern astronomy. An intimate research-intensive environment unlike any other.",
    tuition: { domestic: "$60,864/yr", international: "$60,864/yr" },
    living: "$2,200–$3,000/mo", ielts: "Not required (TOEFL 100+)", gre: "Required",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Aerospace Engineering", duration: "2 years", language: "English" },
      { name: "MS Applied Physics", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "97%", avgSalary: "$105,000–$170,000", topEmployers: ["NASA/JPL", "SpaceX", "Google", "Intel", "Boeing"] },
    intakes: ["September"], istpStudents: 8,
  },

  "university-of-chicago": {
    slug: "university-of-chicago", country: "usa",
    name: "University of Chicago", shortName: "UChicago", flag: "🇺🇸",
    city: "Chicago, Illinois", founded: 1890, qsRank: "#11 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Where the Chicago School of Economics was born. 100 Nobel laureates. UChicago's Booth School of Business consistently ranks #1 globally. Legendary for rigorous intellectual culture, groundbreaking economics research, and producing more Nobel laureates in economics than any other institution.",
    tuition: { domestic: "$63,801/yr", international: "$63,801/yr" },
    living: "$1,800–$2,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Booth School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "1–2 years", language: "English" },
      { name: "MS Financial Mathematics", duration: "1 year", language: "English" },
      { name: "MA Economics", duration: "1 year", language: "English" },
      { name: "MS Data Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "$100,000–$165,000", topEmployers: ["Goldman Sachs", "McKinsey", "Citadel", "Google", "JP Morgan"] },
    intakes: ["September"], istpStudents: 14,
  },

  "columbia-university": {
    slug: "columbia-university", country: "usa",
    name: "Columbia University", shortName: "Columbia", flag: "🇺🇸",
    city: "New York City, New York", founded: 1754, qsRank: "#12 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1534430480872-3498386e7856?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "New York City's Ivy League university. Nestled in Morningside Heights, Manhattan, Columbia offers unrivalled access to Wall Street, media, tech, and the arts. Home to the Pulitzer Prize and with alumni including Barack Obama and Warren Buffett.",
    tuition: { domestic: "$65,524/yr", international: "$65,524/yr" },
    living: "$2,500–$3,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "1–2 years", language: "English" },
      { name: "MBA — Columbia Business School", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "1 year", language: "English" },
      { name: "MS Financial Engineering", duration: "1 year", language: "English" },
      { name: "MS Electrical Engineering", duration: "1–2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$100,000–$165,000", topEmployers: ["Goldman Sachs", "Google", "Amazon", "JP Morgan", "McKinsey"] },
    intakes: ["September", "January"], istpStudents: 20,
  },

  "university-of-pennsylvania": {
    slug: "university-of-pennsylvania", country: "usa",
    name: "University of Pennsylvania", shortName: "UPenn", flag: "🇺🇸",
    city: "Philadelphia, Pennsylvania", founded: 1740, qsRank: "#13 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's first university and home to the Wharton School — the world's most prestigious business school. Penn's unique interdisciplinary model allows students to combine medicine, law, engineering, and business in ways impossible anywhere else.",
    tuition: { domestic: "$63,452/yr", international: "$63,452/yr" },
    living: "$1,800–$2,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Wharton School", duration: "2 years", language: "English" },
      { name: "MS Computer & Information Science", duration: "1–2 years", language: "English" },
      { name: "MS Engineering", duration: "1–2 years", language: "English" },
      { name: "MS Data Science", duration: "1–2 years", language: "English" },
      { name: "LLM — Penn Law", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "$105,000–$175,000", topEmployers: ["Goldman Sachs", "McKinsey", "Google", "Blackstone", "Bain & Company"] },
    intakes: ["September"], istpStudents: 16,
  },

  "yale-university": {
    slug: "yale-university", country: "usa",
    name: "Yale University", shortName: "Yale", flag: "🇺🇸",
    city: "New Haven, Connecticut", founded: 1701, qsRank: "#16 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's third-oldest university and the gold standard for law, drama, and the arts. Yale Law School is the #1 law school in America. Home to five U.S. presidents and 65 Nobel laureates, Yale shapes diplomats, jurists, artists, and business leaders.",
    tuition: { domestic: "$62,250/yr", international: "$62,250/yr" },
    living: "$1,700–$2,600/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "JD — Yale Law School", duration: "3 years", language: "English" },
      { name: "MBA — Yale School of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MFA — Yale School of Drama", duration: "3 years", language: "English" },
      { name: "MPH — Yale School of Public Health", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "$95,000–$165,000", topEmployers: ["Skadden", "McKinsey", "Goldman Sachs", "U.S. DOJ", "Google"] },
    intakes: ["September"], istpStudents: 11,
  },

  "princeton-university": {
    slug: "princeton-university", country: "usa",
    name: "Princeton University", shortName: "Princeton", flag: "🇺🇸",
    city: "Princeton, New Jersey", founded: 1746, qsRank: "#20 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's fourth-oldest university, famed for its gothic campus, intense intellectual community, and the highest endowment-per-student ratio of any university. Princeton has no business or law school — it focuses purely on academic excellence in arts, sciences, engineering, and public policy.",
    tuition: { domestic: "$59,710/yr", international: "$59,710/yr" },
    living: "$1,800–$2,700/mo", ielts: "Not required (TOEFL 100+)", gre: "Required",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MPA — Princeton School of Public & International Affairs", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
      { name: "MS Operations Research & Financial Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "97%", avgSalary: "$100,000–$170,000", topEmployers: ["Google", "Jane Street", "McKinsey", "Goldman Sachs", "U.S. State Dept"] },
    intakes: ["September"], istpStudents: 9,
  },

  "cornell-university": {
    slug: "cornell-university", country: "usa",
    name: "Cornell University", shortName: "Cornell", flag: "🇺🇸",
    city: "Ithaca, New York", founded: 1865, qsRank: "#13 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The most accessible Ivy League — accepting both public and private students since 1865. Cornell's 14 colleges span everything from hotel management to aerospace engineering. Set on a stunning gorge campus in upstate New York, with a second campus in New York City (Cornell Tech).",
    tuition: { domestic: "$61,015/yr", international: "$61,015/yr" },
    living: "$1,500–$2,500/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — Cornell SC Johnson", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
      { name: "MS Operations Research", duration: "2 years", language: "English" },
      { name: "MS Hotel Administration", duration: "1–2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$95,000–$155,000", topEmployers: ["Amazon", "Goldman Sachs", "Google", "Microsoft", "McKinsey"] },
    intakes: ["August", "January"], istpStudents: 18,
  },

  "johns-hopkins-university": {
    slug: "johns-hopkins-university", country: "usa",
    name: "Johns Hopkins University", shortName: "Johns Hopkins", flag: "🇺🇸",
    city: "Baltimore, Maryland", founded: 1876, qsRank: "#25 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's first research university and the global leader in public health, biomedical engineering, and medicine. Home to the world's #1 ranked school of public health. JHU receives more federal research funding than any other U.S. university.",
    tuition: { domestic: "$60,480/yr", international: "$60,480/yr" },
    living: "$1,600–$2,500/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MPH — Bloomberg School of Public Health", duration: "2 years", language: "English" },
      { name: "MS Biomedical Engineering", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Applied Mathematics & Statistics", duration: "2 years", language: "English" },
      { name: "MBA — Carey Business School", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$90,000–$150,000", topEmployers: ["NIH", "FDA", "Johns Hopkins Hospital", "CDC", "Booz Allen Hamilton"] },
    intakes: ["September"], istpStudents: 14,
  },

  "northwestern-university": {
    slug: "northwestern-university", country: "usa",
    name: "Northwestern University", shortName: "Northwestern", flag: "🇺🇸",
    city: "Evanston, Illinois", founded: 1851, qsRank: "#32 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of America's elite private research universities, beautifully situated on the Lake Michigan shoreline. Kellogg School of Management is a top-5 global MBA. Northwestern excels in journalism, medicine, law, and engineering — with Chicago's business ecosystem at its doorstep.",
    tuition: { domestic: "$63,468/yr", international: "$63,468/yr" },
    living: "$1,700–$2,700/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Kellogg School of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Analytics", duration: "1–2 years", language: "English" },
      { name: "JD — Pritzker School of Law", duration: "3 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "$95,000–$155,000", topEmployers: ["McKinsey", "Amazon", "Google", "Deloitte", "Goldman Sachs"] },
    intakes: ["September"], istpStudents: 16,
  },

  "duke-university": {
    slug: "duke-university", country: "usa",
    name: "Duke University", shortName: "Duke", flag: "🇺🇸",
    city: "Durham, North Carolina", founded: 1838, qsRank: "#66 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of America's most prestigious private universities set in a stunning Gothic campus. Fuqua School of Business is a top-10 global MBA. Duke is world-leading in environmental policy, medicine, and AI, and sits at the heart of North Carolina's Research Triangle.",
    tuition: { domestic: "$62,688/yr", international: "$62,688/yr" },
    living: "$1,500–$2,400/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Fuqua School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
      { name: "MEM — Master of Engineering Management", duration: "1 year", language: "English" },
      { name: "MS Environmental Management", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$90,000–$150,000", topEmployers: ["McKinsey", "Amazon", "Bain & Company", "Google", "Goldman Sachs"] },
    intakes: ["August"], istpStudents: 17,
  },

  "vanderbilt-university": {
    slug: "vanderbilt-university", country: "usa",
    name: "Vanderbilt University", shortName: "Vanderbilt", flag: "🇺🇸",
    city: "Nashville, Tennessee", founded: 1873, qsRank: "#198 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-15 U.S. university in America's fastest-growing city. Vanderbilt is exceptional in education, medicine, and law. Owen Graduate School of Management is highly ranked and Nashville's booming healthcare and technology economy opens exceptional career doors.",
    tuition: { domestic: "$60,348/yr", international: "$60,348/yr" },
    living: "$1,400–$2,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Owen Graduate School of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "1–2 years", language: "English" },
      { name: "MEd — Peabody College of Education", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$85,000–$140,000", topEmployers: ["Amazon", "Deloitte", "HCA Healthcare", "McKinsey", "Google"] },
    intakes: ["August"], istpStudents: 13,
  },

  "university-of-michigan": {
    slug: "university-of-michigan", country: "usa",
    name: "University of Michigan", shortName: "U-Michigan", flag: "🇺🇸",
    city: "Ann Arbor, Michigan", founded: 1817, qsRank: "#23 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's top public research university — the 'Harvard of the Midwest.' Ross School of Business is a top-15 MBA globally. U-Michigan consistently leads in research funding among public universities and has produced more Fortune 500 CEOs than any other school in the U.S.",
    tuition: { domestic: "$22,286/yr", international: "$55,334/yr" },
    living: "$1,400–$2,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science & Engineering", duration: "2 years", language: "English" },
      { name: "MBA — Ross School of Business", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Information", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$90,000–$150,000", topEmployers: ["Google", "Amazon", "Ford", "McKinsey", "Goldman Sachs"] },
    intakes: ["September", "January"], istpStudents: 28,
  },

  "uc-berkeley": {
    slug: "uc-berkeley", country: "usa",
    name: "University of California, Berkeley", shortName: "UC Berkeley", flag: "🇺🇸",
    city: "Berkeley, California", founded: 1868, qsRank: "#28 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's top public university and birthplace of the free speech movement. Berkeley has produced 107 Nobel laureates and sits at the edge of Silicon Valley with unparalleled tech industry access. Haas School of Business is the most selective MBA program in the world.",
    tuition: { domestic: "$14,312/yr", international: "$44,066/yr" },
    living: "$2,000–$3,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS EECS", duration: "2 years", language: "English" },
      { name: "MBA — Haas School of Business", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MEng Engineering", duration: "1 year", language: "English" },
      { name: "MS Industrial Engineering & Operations Research", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "$95,000–$160,000", topEmployers: ["Google", "Apple", "Meta", "McKinsey", "Salesforce"] },
    intakes: ["August", "January"], istpStudents: 25,
  },

  "ucla": {
    slug: "ucla", country: "usa",
    name: "University of California, Los Angeles", shortName: "UCLA", flag: "🇺🇸",
    city: "Los Angeles, California", founded: 1919, qsRank: "#44 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The most applied-to university in the U.S. — for good reason. UCLA sits in the heart of Los Angeles, with access to Hollywood, Silicon Beach, and a $1 trillion economy. Anderson School of Management is a top-15 MBA. UCLA excels in film, engineering, medicine, and public policy.",
    tuition: { domestic: "$13,804/yr", international: "$43,474/yr" },
    living: "$2,000–$3,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Anderson School of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
      { name: "MS Data Science Engineering", duration: "2 years", language: "English" },
      { name: "MFA — UCLA School of Theater, Film & Television", duration: "2–3 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$88,000–$148,000", topEmployers: ["Google", "Amazon", "Walt Disney", "Deloitte", "Apple"] },
    intakes: ["September"], istpStudents: 22,
  },

  "new-york-university": {
    slug: "new-york-university", country: "usa",
    name: "New York University", shortName: "NYU", flag: "🇺🇸",
    city: "New York City, New York", founded: 1831, qsRank: "#38 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1534430480872-3498386e7856?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's most globally connected university with campuses in New York, Abu Dhabi, and Shanghai. Stern School of Business is a top Wall Street feeder. NYU's location in Greenwich Village puts students at the intersection of finance, media, fashion, and tech.",
    tuition: { domestic: "$58,168/yr", international: "$58,168/yr" },
    living: "$2,500–$3,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Stern School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Quantitative Finance", duration: "2 years", language: "English" },
      { name: "MFA — Tisch School of the Arts", duration: "2–3 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$88,000–$148,000", topEmployers: ["Goldman Sachs", "Google", "JP Morgan", "Amazon", "Deloitte"] },
    intakes: ["September", "January"], istpStudents: 24,
  },

  "carnegie-mellon-university": {
    slug: "carnegie-mellon-university", country: "usa",
    name: "Carnegie Mellon University", shortName: "CMU", flag: "🇺🇸",
    city: "Pittsburgh, Pennsylvania", founded: 1900, qsRank: "#52 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's #1 university for computer science and AI. CMU's School of Computer Science has produced more tech unicorn founders than any comparable program. Home to pioneering robotics, machine learning, and HCI research. Tepper School of Business is a top-15 MBA.",
    tuition: { domestic: "$59,864/yr", international: "$59,864/yr" },
    living: "$1,400–$2,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Machine Learning", duration: "2 years", language: "English" },
      { name: "MS Robotics", duration: "2 years", language: "English" },
      { name: "MBA — Tepper School of Business", duration: "2 years", language: "English" },
      { name: "MS Information Security", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "97%", avgSalary: "$105,000–$175,000", topEmployers: ["Google", "Meta", "Apple", "Microsoft", "Amazon"] },
    intakes: ["August", "January"], istpStudents: 19,
  },

  "university-of-texas-austin": {
    slug: "university-of-texas-austin", country: "usa",
    name: "University of Texas at Austin", shortName: "UT Austin", flag: "🇺🇸",
    city: "Austin, Texas", founded: 1883, qsRank: "#67 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The flagship of the Lone Star State and one of America's great public universities. Located in Austin — the fastest-growing tech city in America, now home to Tesla, Apple, and Oracle headquarters. McCombs School of Business is a top-20 MBA with exceptional Texas industry ties.",
    tuition: { domestic: "$11,998/yr", international: "$39,506/yr" },
    living: "$1,400–$2,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — McCombs School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
      { name: "MS Petroleum Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$85,000–$145,000", topEmployers: ["Dell", "Apple", "Tesla", "Amazon", "ExxonMobil"] },
    intakes: ["August", "January"], istpStudents: 26,
  },

  "georgia-tech": {
    slug: "georgia-tech", country: "usa",
    name: "Georgia Institute of Technology", shortName: "Georgia Tech", flag: "🇺🇸",
    city: "Atlanta, Georgia", founded: 1885, qsRank: "#97 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's best-value elite engineering university. Georgia Tech's online MS Computer Science is the most enrolled graduate program in the world. Located in Atlanta — the economic capital of the U.S. Southeast, with Coca-Cola, Delta, and NCR all headquartered nearby.",
    tuition: { domestic: "$14,064/yr", international: "$31,370/yr" },
    living: "$1,300–$2,100/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
      { name: "MS Analytics", duration: "1–2 years", language: "English" },
      { name: "MBA — Scheller College of Business", duration: "2 years", language: "English" },
      { name: "MS Industrial Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "$90,000–$150,000", topEmployers: ["Google", "Amazon", "Delta Air Lines", "Boeing", "Lockheed Martin"] },
    intakes: ["August", "January"], istpStudents: 30,
  },

  "university-of-illinois-urbana": {
    slug: "university-of-illinois-urbana", country: "usa",
    name: "University of Illinois Urbana-Champaign", shortName: "UIUC", flag: "🇺🇸",
    city: "Champaign, Illinois", founded: 1867, qsRank: "#35 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Where the Mosaic web browser and YouTube were invented. UIUC's Grainger College of Engineering and Gies College of Business are both top-10 nationally. A powerhouse for CS, engineering, and accounting, with the largest on-campus engineering faculty in the U.S.",
    tuition: { domestic: "$17,572/yr", international: "$36,068/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — Gies College of Business", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Accountancy", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$88,000–$148,000", topEmployers: ["Google", "Amazon", "Microsoft", "Caterpillar", "Deloitte"] },
    intakes: ["August", "January"], istpStudents: 35,
  },

  "purdue-university": {
    slug: "purdue-university", country: "usa",
    name: "Purdue University", shortName: "Purdue", flag: "🇺🇸",
    city: "West Lafayette, Indiana", founded: 1869, qsRank: "#109 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The 'Cradle of Astronauts' — more Purdue alumni have flown in space than from any other university, including Neil Armstrong. Purdue is a top-10 engineering university nationally, world-class in aeronautical engineering, and among the most affordable elite STEM destinations.",
    tuition: { domestic: "$10,002/yr", international: "$29,128/yr" },
    living: "$1,100–$1,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Aeronautical & Astronautical Engineering", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — Mitchell E. Daniels Jr. School of Business", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$80,000–$135,000", topEmployers: ["Boeing", "NASA", "Caterpillar", "Amazon", "Raytheon"] },
    intakes: ["August", "January"], istpStudents: 27,
  },

  "university-of-washington": {
    slug: "university-of-washington", country: "usa",
    name: "University of Washington", shortName: "UW Seattle", flag: "🇺🇸",
    city: "Seattle, Washington", founded: 1861, qsRank: "#85 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of the world's great public research universities, situated in Seattle — home to Amazon, Microsoft, and Boeing. UW is consistently #1 in the world for clinical medicine and #1 in the U.S. for computer science among public universities.",
    tuition: { domestic: "$12,643/yr", international: "$39,906/yr" },
    living: "$1,800–$2,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science & Engineering", duration: "2 years", language: "English" },
      { name: "MBA — Foster School of Business", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Information Management", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$92,000–$155,000", topEmployers: ["Amazon", "Microsoft", "Google", "Boeing", "Apple"] },
    intakes: ["September", "January"], istpStudents: 23,
  },

  "university-of-southern-california": {
    slug: "university-of-southern-california", country: "usa",
    name: "University of Southern California", shortName: "USC", flag: "🇺🇸",
    city: "Los Angeles, California", founded: 1880, qsRank: "#113 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The Entertainment Capital's university. USC Marshall is a top-20 business school and the Annenberg School for Communication is the world's finest for media. USC's alumni network — the 'Trojan Family' — is one of the most powerful in California's tech and entertainment industries.",
    tuition: { domestic: "$64,726/yr", international: "$64,726/yr" },
    living: "$2,000–$3,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Marshall School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
      { name: "MS Communication Management", duration: "2 years", language: "English" },
      { name: "MFA — School of Cinematic Arts", duration: "2–3 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$85,000–$145,000", topEmployers: ["Google", "Amazon", "Disney", "Deloitte", "Warner Bros"] },
    intakes: ["August", "January"], istpStudents: 21,
  },

  "boston-university": {
    slug: "boston-university", country: "usa",
    name: "Boston University", shortName: "BU", flag: "🇺🇸",
    city: "Boston, Massachusetts", founded: 1839, qsRank: "#113 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Located in the heart of Boston — the world's leading educational and biotech city. BU Questrom is a strong business school, and the Photonics Center is a world-leading research facility. With MIT, Harvard, and Northeastern nearby, Boston's academic ecosystem is second to none.",
    tuition: { domestic: "$60,792/yr", international: "$60,792/yr" },
    living: "$1,800–$2,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — Questrom School of Business", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Biomedical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$80,000–$135,000", topEmployers: ["Google", "State Street", "PwC", "Amazon", "Raytheon"] },
    intakes: ["September", "January"], istpStudents: 20,
  },

  "university-of-notre-dame": {
    slug: "university-of-notre-dame", country: "usa",
    name: "University of Notre Dame", shortName: "Notre Dame", flag: "🇺🇸",
    city: "Notre Dame, Indiana", founded: 1842, qsRank: "#204 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's most beloved Catholic university with one of the most loyal and powerful alumni networks in the U.S. Mendoza College of Business consistently ranks #1 for undergraduate business and is a strong MBA. Notre Dame is exceptional for law, public policy, and finance.",
    tuition: { domestic: "$60,301/yr", international: "$60,301/yr" },
    living: "$1,300–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Mendoza College of Business", duration: "2 years", language: "English" },
      { name: "JD — Notre Dame Law School", duration: "3 years", language: "English" },
      { name: "MS Computer Science & Engineering", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$85,000–$140,000", topEmployers: ["Deloitte", "Goldman Sachs", "PwC", "Amazon", "EY"] },
    intakes: ["August"], istpStudents: 11,
  },

  "ohio-state-university": {
    slug: "ohio-state-university", country: "usa",
    name: "Ohio State University", shortName: "Ohio State", flag: "🇺🇸",
    city: "Columbus, Ohio", founded: 1870, qsRank: "#201 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of America's largest and most comprehensive public universities. Ohio State is a top-15 public research university with a leading business school, engineering college, and medical center. Columbus is America's fastest-growing Midwest tech hub, with JPMorgan, Nationwide, and Intel nearby.",
    tuition: { domestic: "$12,485/yr", international: "$36,722/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Fisher College of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science & Engineering", duration: "2 years", language: "English" },
      { name: "MS Data Analytics", duration: "1 year", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$78,000–$130,000", topEmployers: ["JP Morgan", "Intel", "Amazon", "Deloitte", "L Brands"] },
    intakes: ["August", "January"], istpStudents: 24,
  },

  "penn-state-university": {
    slug: "penn-state-university", country: "usa",
    name: "Pennsylvania State University", shortName: "Penn State", flag: "🇺🇸",
    city: "University Park, Pennsylvania", founded: 1855, qsRank: "#249 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of the largest and most respected public research universities in the U.S. Penn State's Smeal College of Business and College of Engineering are both nationally ranked. Nittany Lion alumni form one of the most powerful university networks in corporate America.",
    tuition: { domestic: "$18,450/yr", international: "$37,476/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Smeal College of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Analytics", duration: "2 years", language: "English" },
      { name: "MS Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$75,000–$128,000", topEmployers: ["Boeing", "Deloitte", "Amazon", "PwC", "EY"] },
    intakes: ["August", "January"], istpStudents: 22,
  },

  "university-of-minnesota": {
    slug: "university-of-minnesota", country: "usa",
    name: "University of Minnesota", shortName: "U of M", flag: "🇺🇸",
    city: "Minneapolis, Minnesota", founded: 1851, qsRank: "#183 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-15 public research university known for pioneering medical breakthroughs — including the first open-heart surgery. Carlson School of Management is a strong MBA with excellent ties to Target, 3M, and Best Buy. Minneapolis is one of the most liveable cities in the U.S.",
    tuition: { domestic: "$16,488/yr", international: "$34,766/yr" },
    living: "$1,300–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Carlson School of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Biomedical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$78,000–$130,000", topEmployers: ["3M", "Target", "Best Buy", "Medtronic", "General Mills"] },
    intakes: ["September", "January"], istpStudents: 18,
  },

  "university-of-wisconsin-madison": {
    slug: "university-of-wisconsin-madison", country: "usa",
    name: "University of Wisconsin-Madison", shortName: "UW-Madison", flag: "🇺🇸",
    city: "Madison, Wisconsin", founded: 1848, qsRank: "#163 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A flagship Big Ten research university with a beautiful lakeside campus. UW-Madison is a top-10 public university for research funding and excellence in biochemistry, engineering, computer science, and business. Madison is consistently ranked one of the best college towns in America.",
    tuition: { domestic: "$11,270/yr", international: "$38,672/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Wisconsin School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Sciences", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
      { name: "MS Statistics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$78,000–$130,000", topEmployers: ["Amazon", "Epic Systems", "Deloitte", "Apple", "Google"] },
    intakes: ["August", "January"], istpStudents: 21,
  },

  "rutgers-university": {
    slug: "rutgers-university", country: "usa",
    name: "Rutgers University", shortName: "Rutgers", flag: "🇺🇸",
    city: "New Brunswick, New Jersey", founded: 1766, qsRank: "#392 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of America's oldest and most respected public universities. Located in the New York-New Jersey metro — the world's largest economic region. Rutgers Business School is AACSB-accredited with strong pharma, finance, and tech industry connections in New Jersey.",
    tuition: { domestic: "$15,507/yr", international: "$32,189/yr" },
    living: "$1,500–$2,500/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Rutgers Business School", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Pharmaceutical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$75,000–$125,000", topEmployers: ["Johnson & Johnson", "Amazon", "Deloitte", "Google", "JP Morgan"] },
    intakes: ["September", "January"], istpStudents: 23,
  },

  "university-of-florida": {
    slug: "university-of-florida", country: "usa",
    name: "University of Florida", shortName: "UF", flag: "🇺🇸",
    city: "Gainesville, Florida", founded: 1853, qsRank: "#257 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Florida's flagship university and one of the most comprehensive public universities in the U.S. Consistently a top-10 public university in national rankings. The Warrington College of Business and the Herbert Wertheim College of Engineering are both nationally respected.",
    tuition: { domestic: "$6,381/yr", international: "$28,658/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.0+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Warrington College of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
      { name: "MS Agricultural & Life Sciences", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$72,000–$120,000", topEmployers: ["Amazon", "Lockheed Martin", "Deloitte", "L3 Technologies", "Google"] },
    intakes: ["August", "January"], istpStudents: 22,
  },

  "unc-chapel-hill": {
    slug: "unc-chapel-hill", country: "usa",
    name: "University of North Carolina at Chapel Hill", shortName: "UNC Chapel Hill", flag: "🇺🇸",
    city: "Chapel Hill, North Carolina", founded: 1789, qsRank: "#311 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's first public university and a jewel of the Research Triangle. UNC's Kenan-Flagler Business School is a top-20 MBA. Gillings School of Public Health is among the top-5 globally. UNC and Duke's Research Triangle is home to IBM, Cisco, SAS, and thousands of biotech companies.",
    tuition: { domestic: "$9,005/yr", international: "$36,159/yr" },
    living: "$1,300–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Kenan-Flagler Business School", duration: "2 years", language: "English" },
      { name: "MPH — Gillings School of Public Health", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$80,000–$138,000", topEmployers: ["Deloitte", "Amazon", "McKinsey", "Google", "Bank of America"] },
    intakes: ["August"], istpStudents: 19,
  },

  "university-of-virginia": {
    slug: "university-of-virginia", country: "usa",
    name: "University of Virginia", shortName: "UVA", flag: "🇺🇸",
    city: "Charlottesville, Virginia", founded: 1819, qsRank: "#355 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Thomas Jefferson's university — a UNESCO World Heritage Site campus. Darden School of Business is consistently a top-15 MBA globally and #1 for case method teaching. UVA's law school is one of America's most prestigious, and the McIntire School of Commerce is ranked #1 for undergraduate business.",
    tuition: { domestic: "$18,059/yr", international: "$52,218/yr" },
    living: "$1,300–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Darden School of Business", duration: "2 years", language: "English" },
      { name: "JD — UVA School of Law", duration: "3 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$85,000–$145,000", topEmployers: ["McKinsey", "Deloitte", "Amazon", "Goldman Sachs", "U.S. Government"] },
    intakes: ["August"], istpStudents: 16,
  },

  "rice-university": {
    slug: "rice-university", country: "usa",
    name: "Rice University", shortName: "Rice", flag: "🇺🇸",
    city: "Houston, Texas", founded: 1912, qsRank: "#160 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of America's elite private research universities — often called the 'Harvard of the South.' Sitting in Houston — the energy capital of the world and home to NASA's Johnson Space Center — Rice offers extraordinary opportunities in engineering, medicine, and business with a remarkably small, intimate campus.",
    tuition: { domestic: "$54,960/yr", international: "$54,960/yr" },
    living: "$1,500–$2,400/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Jones Graduate School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$90,000–$150,000", topEmployers: ["ExxonMobil", "Shell", "Amazon", "Google", "Chevron"] },
    intakes: ["August"], istpStudents: 12,
  },

  "washington-university-st-louis": {
    slug: "washington-university-st-louis", country: "usa",
    name: "Washington University in St. Louis", shortName: "WashU", flag: "🇺🇸",
    city: "St. Louis, Missouri", founded: 1853, qsRank: "#171 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-15 U.S. private research university with one of the most beautiful collegiate Gothic campuses in America. Olin Business School is a rising star MBA. WashU is exceptional in medicine, social work, engineering, and law. Consistently among the most generous with financial aid.",
    tuition: { domestic: "$59,420/yr", international: "$59,420/yr" },
    living: "$1,300–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Olin Business School", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MSW — Brown School of Social Work", duration: "2 years", language: "English" },
      { name: "MS Data Analytics & Statistics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$85,000–$140,000", topEmployers: ["Deloitte", "Amazon", "Anheuser-Busch", "Centene", "McKinsey"] },
    intakes: ["August"], istpStudents: 13,
  },

  "emory-university": {
    slug: "emory-university", country: "usa",
    name: "Emory University", shortName: "Emory", flag: "🇺🇸",
    city: "Atlanta, Georgia", founded: 1836, qsRank: "#284 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-25 U.S. research university located in Atlanta — a global business hub. Goizueta Business School is one of the most selective MBAs in the U.S. Emory is home to the CDC, has exceptional public health and medical programs, and a close relationship with the Carter Center.",
    tuition: { domestic: "$57,108/yr", international: "$57,108/yr" },
    living: "$1,400–$2,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Goizueta Business School", duration: "2 years", language: "English" },
      { name: "MPH — Rollins School of Public Health", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "JD — Emory School of Law", duration: "3 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$82,000–$138,000", topEmployers: ["Deloitte", "Goldman Sachs", "McKinsey", "CDC", "Coca-Cola"] },
    intakes: ["August"], istpStudents: 14,
  },

  "tufts-university": {
    slug: "tufts-university", country: "usa",
    name: "Tufts University", shortName: "Tufts", flag: "🇺🇸",
    city: "Medford, Massachusetts", founded: 1852, qsRank: "#303 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "An elite research university in the Boston metro with unique strengths in international relations, veterinary science, and engineering. The Fletcher School is America's oldest and most prestigious school of international affairs. Tufts' proximity to Harvard, MIT, and Boston's biotech corridor creates extraordinary research opportunities.",
    tuition: { domestic: "$63,804/yr", international: "$63,804/yr" },
    living: "$1,800–$2,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MALD/MA — Fletcher School of International Affairs", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Biomedical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$80,000–$130,000", topEmployers: ["U.S. State Dept", "Raytheon", "Amazon", "Deloitte", "USAID"] },
    intakes: ["September"], istpStudents: 13,
  },

  "georgetown-university": {
    slug: "georgetown-university", country: "usa",
    name: "Georgetown University", shortName: "Georgetown", flag: "🇺🇸",
    city: "Washington, D.C.", founded: 1789, qsRank: "#293 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's oldest Catholic and Jesuit university, set in the nation's capital. Georgetown Law is a top-10 law school and the McDonough School of Business feeds directly into Washington's policy, government, and international finance circles. Georgetown is an unrivalled launchpad for diplomacy, policy, and law careers.",
    tuition: { domestic: "$58,656/yr", international: "$58,656/yr" },
    living: "$2,000–$3,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "JD — Georgetown Law", duration: "3 years", language: "English" },
      { name: "MBA — McDonough School of Business", duration: "2 years", language: "English" },
      { name: "MS Foreign Service", duration: "2 years", language: "English" },
      { name: "MS Data Science for Public Policy", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$85,000–$145,000", topEmployers: ["U.S. Congress", "McKinsey", "Deloitte", "World Bank", "Goldman Sachs"] },
    intakes: ["August"], istpStudents: 14,
  },

  "university-of-maryland": {
    slug: "university-of-maryland", country: "usa",
    name: "University of Maryland, College Park", shortName: "UMD", flag: "🇺🇸",
    city: "College Park, Maryland", founded: 1856, qsRank: "#161 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Maryland's flagship public university located minutes from Washington, D.C. Smith School of Business is a top-20 public MBA. UMD has exceptional ties to U.S. federal agencies — NSA, NIST, NASA Goddard, and the Department of Defense are all nearby, creating extraordinary career paths in cybersecurity and government.",
    tuition: { domestic: "$11,505/yr", international: "$40,306/yr" },
    living: "$1,500–$2,500/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Smith School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Cybersecurity", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$80,000–$135,000", topEmployers: ["Amazon", "Lockheed Martin", "NSA", "Deloitte", "Google"] },
    intakes: ["August", "January"], istpStudents: 20,
  },

  "university-of-pittsburgh": {
    slug: "university-of-pittsburgh", country: "usa",
    name: "University of Pittsburgh", shortName: "Pitt", flag: "🇺🇸",
    city: "Pittsburgh, Pennsylvania", founded: 1787, qsRank: "#210 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of America's oldest and most respected research universities, with a magnificent Gothic cathedral of learning at its heart. Pitt is exceptional in medicine, law, engineering, and public health. Pittsburgh's renaissance as a tech and robotics hub — with Uber, Google, and Carnegie Mellon nearby — creates outstanding career opportunities.",
    tuition: { domestic: "$20,744/yr", international: "$36,384/yr" },
    living: "$1,300–$2,100/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Katz Graduate School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MPH — Public Health", duration: "2 years", language: "English" },
      { name: "MS Electrical & Computer Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$75,000–$128,000", topEmployers: ["PNC Bank", "UPMC", "Deloitte", "Amazon", "Google"] },
    intakes: ["August", "January"], istpStudents: 17,
  },

  "arizona-state-university": {
    slug: "arizona-state-university", country: "usa",
    name: "Arizona State University", shortName: "ASU", flag: "🇺🇸",
    city: "Tempe, Arizona", founded: 1885, qsRank: "#216 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The most innovative university in America according to U.S. News — for 9 consecutive years. ASU is reinventing public higher education with bold online programs, a massive research enterprise, and strong industry ties to Intel, Honeywell, and Boeing. The W. P. Carey School of Business is a top-25 MBA.",
    tuition: { domestic: "$12,735/yr", international: "$31,200/yr" },
    living: "$1,200–$2,000/mo", ielts: "6.5+", gre: "Not required for most programs",
    topCourses: [
      { name: "MBA — W. P. Carey School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science, Analytics & Engineering", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$72,000–$120,000", topEmployers: ["Intel", "Honeywell", "Amazon", "Deloitte", "Boeing"] },
    intakes: ["August", "January"], istpStudents: 26,
  },

  "texas-a-and-m-university": {
    slug: "texas-a-and-m-university", country: "usa",
    name: "Texas A&M University", shortName: "Texas A&M", flag: "🇺🇸",
    city: "College Station, Texas", founded: 1876, qsRank: "#172 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of the largest universities in America by enrollment, with one of the most loyal alumni networks. Texas A&M is a top-20 public research university with outstanding programs in engineering, agriculture, business, and veterinary medicine. The Mays Business School has strong Texas industry ties.",
    tuition: { domestic: "$12,413/yr", international: "$38,946/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Mays Business School", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$78,000–$132,000", topEmployers: ["ExxonMobil", "Amazon", "Deloitte", "Boeing", "Shell"] },
    intakes: ["August", "January"], istpStudents: 24,
  },

  "michigan-state-university": {
    slug: "michigan-state-university", country: "usa",
    name: "Michigan State University", shortName: "MSU", flag: "🇺🇸",
    city: "East Lansing, Michigan", founded: 1855, qsRank: "#224 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's pioneer land-grant university with one of the most beautiful campuses in the country. MSU is exceptional in supply chain management, food science, veterinary science, and business. The Broad College of Business supply chain program is consistently ranked #1 in the nation.",
    tuition: { domestic: "$15,260/yr", international: "$41,958/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Broad College of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Supply Chain Management", duration: "1 year", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$72,000–$120,000", topEmployers: ["GM", "Ford", "Deloitte", "Amazon", "EY"] },
    intakes: ["August", "January"], istpStudents: 21,
  },

  "indiana-university-bloomington": {
    slug: "indiana-university-bloomington", country: "usa",
    name: "Indiana University Bloomington", shortName: "IU Bloomington", flag: "🇺🇸",
    city: "Bloomington, Indiana", founded: 1820, qsRank: "#371 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of America's great flagship public universities with an exceptional campus. The Kelley School of Business is consistently ranked #1 for undergraduate business and a top-20 MBA. IU is exceptional for music (Jacobs School) and has one of the most vibrant international student communities in the Midwest.",
    tuition: { domestic: "$11,378/yr", international: "$36,512/yr" },
    living: "$1,100–$1,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Kelley School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MMus — Jacobs School of Music", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$72,000–$122,000", topEmployers: ["Deloitte", "PwC", "Amazon", "EY", "IBM"] },
    intakes: ["August", "January"], istpStudents: 20,
  },

  "university-of-iowa": {
    slug: "university-of-iowa", country: "usa",
    name: "University of Iowa", shortName: "U of Iowa", flag: "🇺🇸",
    city: "Iowa City, Iowa", founded: 1847, qsRank: "#427 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A well-respected Big Ten research university famous for the Iowa Writers' Workshop — the most prestigious creative writing program in the world. The Tippie College of Business is AACSB-accredited. Iowa is recognized nationally for its health sciences, biomedical research, and affordable tuition.",
    tuition: { domestic: "$9,946/yr", international: "$32,062/yr" },
    living: "$1,100–$1,700/mo", ielts: "6.0+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Tippie College of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Biomedical Engineering", duration: "2 years", language: "English" },
      { name: "MFA — Iowa Writers' Workshop", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$68,000–$115,000", topEmployers: ["Rockwell Collins", "Deloitte", "Amazon", "PwC", "Principal Financial"] },
    intakes: ["August", "January"], istpStudents: 16,
  },

  "university-of-colorado-boulder": {
    slug: "university-of-colorado-boulder", country: "usa",
    name: "University of Colorado Boulder", shortName: "CU Boulder", flag: "🇺🇸",
    city: "Boulder, Colorado", founded: 1876, qsRank: "#237 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A flagship research university in America's most outdoor-loving city. CU Boulder has 6 Nobel laureates and is world-class in aerospace, atmospheric science, and quantum computing. The Leeds School of Business is AACSB-accredited and Boulder's booming tech startup scene creates exceptional entrepreneurship opportunities.",
    tuition: { domestic: "$13,048/yr", international: "$38,052/yr" },
    living: "$1,500–$2,400/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Leeds School of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Aerospace Engineering Sciences", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$78,000–$130,000", topEmployers: ["Google", "Ball Aerospace", "Amazon", "Lockheed Martin", "IBM"] },
    intakes: ["August", "January"], istpStudents: 18,
  },

  "university-of-arizona": {
    slug: "university-of-arizona", country: "usa",
    name: "University of Arizona", shortName: "U of A", flag: "🇺🇸",
    city: "Tucson, Arizona", founded: 1885, qsRank: "#301 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-tier public research university ranked #1 in the U.S. for space sciences. The UA is home to the Mirror Lab — which builds the world's largest telescope mirrors — and has exceptional programs in optical sciences, astronomy, medicine, and business. Tucson's lower cost of living makes it highly affordable.",
    tuition: { domestic: "$12,467/yr", international: "$37,029/yr" },
    living: "$1,100–$1,800/mo", ielts: "6.0+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Eller College of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Optical Sciences", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$70,000–$118,000", topEmployers: ["Raytheon", "Amazon", "Intel", "Deloitte", "Arizona Department of Health"] },
    intakes: ["August", "January"], istpStudents: 17,
  },

  "university-of-california-san-diego": {
    slug: "university-of-california-san-diego", country: "usa",
    name: "University of California San Diego", shortName: "UC San Diego", flag: "🇺🇸",
    city: "La Jolla, California", founded: 1960, qsRank: "#62 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top global research university on the Pacific Ocean cliffs of La Jolla. UC San Diego is ranked #1 in the U.S. for ocean sciences and has exceptional computer science, bioengineering, and medicine programs. San Diego's booming biotech corridor — second only to Boston — creates outstanding career paths for life sciences graduates.",
    tuition: { domestic: "$14,312/yr", international: "$44,066/yr" },
    living: "$1,900–$3,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — Rady School of Management", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
      { name: "MS Bioengineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$90,000–$150,000", topEmployers: ["Qualcomm", "Amazon", "Google", "Illumina", "Apple"] },
    intakes: ["September"], istpStudents: 22,
  },

  "university-of-california-davis": {
    slug: "university-of-california-davis", country: "usa",
    name: "University of California Davis", shortName: "UC Davis", flag: "🇺🇸",
    city: "Davis, California", founded: 1905, qsRank: "#148 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top global research university with the world's #1 ranked veterinary school and outstanding programs in agriculture, food science, biological sciences, and engineering. Located in California's Central Valley — the food basket of America — with easy access to Silicon Valley and Sacramento.",
    tuition: { domestic: "$14,312/yr", international: "$44,066/yr" },
    living: "$1,500–$2,400/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Graduate School of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Agricultural & Environmental Chemistry", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$82,000–$138,000", topEmployers: ["Amazon", "Apple", "Google", "Intel", "USDA"] },
    intakes: ["September", "January"], istpStudents: 20,
  },

  "boston-college": {
    slug: "boston-college", country: "usa",
    name: "Boston College", shortName: "BC", flag: "🇺🇸",
    city: "Chestnut Hill, Massachusetts", founded: 1863, qsRank: "#413 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-35 national university with one of America's most stunning Gothic campuses. The Carroll School of Management has outstanding finance and accounting programs. Boston College Law School is a top-25 law school, and the Connell School of Nursing is ranked #1 in New England.",
    tuition: { domestic: "$62,950/yr", international: "$62,950/yr" },
    living: "$1,800–$2,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Carroll School of Management", duration: "2 years", language: "English" },
      { name: "MS Finance", duration: "1 year", language: "English" },
      { name: "JD — Boston College Law School", duration: "3 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$80,000–$135,000", topEmployers: ["Fidelity Investments", "PwC", "Deloitte", "State Street", "Amazon"] },
    intakes: ["September"], istpStudents: 14,
  },

  "lehigh-university": {
    slug: "lehigh-university", country: "usa",
    name: "Lehigh University", shortName: "Lehigh", flag: "🇺🇸",
    city: "Bethlehem, Pennsylvania", founded: 1865, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A prestigious private research university in the Lehigh Valley, an hour from both New York and Philadelphia. Lehigh is exceptional in engineering, business, and the integration of both. The integrated business and engineering (IBE) programs are among the most innovative in America.",
    tuition: { domestic: "$58,680/yr", international: "$58,680/yr" },
    living: "$1,300–$2,100/mo", ielts: "6.5+", gre: "Required for some programs",
    topCourses: [
      { name: "MBA — College of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$80,000–$135,000", topEmployers: ["Air Products", "Deloitte", "Amazon", "PwC", "Goldman Sachs"] },
    intakes: ["August"], istpStudents: 13,
  },

  "tulane-university": {
    slug: "tulane-university", country: "usa",
    name: "Tulane University", shortName: "Tulane", flag: "🇺🇸",
    city: "New Orleans, Louisiana", founded: 1834, qsRank: "#501 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-50 national university set in the heart of New Orleans — the most culturally vibrant city in America. Freeman School of Business is known for energy, finance, and international business. Tulane School of Public Health is exceptional for tropical medicine and disaster relief.",
    tuition: { domestic: "$59,690/yr", international: "$59,690/yr" },
    living: "$1,500–$2,400/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Freeman School of Business", duration: "2 years", language: "English" },
      { name: "MPH — School of Public Health", duration: "2 years", language: "English" },
      { name: "JD — Tulane Law School", duration: "3 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$72,000–$120,000", topEmployers: ["Chevron", "Shell", "EY", "Deloitte", "Amazon"] },
    intakes: ["August"], istpStudents: 12,
  },

  "university-of-miami": {
    slug: "university-of-miami", country: "usa",
    name: "University of Miami", shortName: "U of Miami", flag: "🇺🇸",
    city: "Coral Gables, Florida", founded: 1925, qsRank: "#501 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-50 research university in one of the world's most dynamic cities. Miami's boom as a global finance and tech hub — attracting Citadel, Blackstone, and thousands of startups — has transformed UM's business school. Excellent for marine science, medicine, and international business, with Latin America connections unmatched by any other U.S. university.",
    tuition: { domestic: "$57,860/yr", international: "$57,860/yr" },
    living: "$1,800–$2,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Miami Herbert Business School", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Marine Biology", duration: "2 years", language: "English" },
      { name: "MS Finance", duration: "1–2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$72,000–$122,000", topEmployers: ["Citadel", "Deloitte", "Amazon", "Baptist Health", "EY"] },
    intakes: ["August", "January"], istpStudents: 15,
  },

  "syracuse-university": {
    slug: "syracuse-university", country: "usa",
    name: "Syracuse University", shortName: "Syracuse", flag: "🇺🇸",
    city: "Syracuse, New York", founded: 1870, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A leading private research university with America's most highly ranked communications school — the Newhouse School. Syracuse is exceptional for journalism, public relations, advertising, and sports management. The Whitman School of Management is AACSB-accredited with strong industry ties.",
    tuition: { domestic: "$58,440/yr", international: "$58,440/yr" },
    living: "$1,300–$2,000/mo", ielts: "6.5+", gre: "Required for some programs",
    topCourses: [
      { name: "MS Communications — Newhouse School", duration: "2 years", language: "English" },
      { name: "MBA — Whitman School of Management", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Sport Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$70,000–$118,000", topEmployers: ["ESPN", "NBC", "Deloitte", "Amazon", "PwC"] },
    intakes: ["August", "January"], istpStudents: 15,
  },

  "drexel-university": {
    slug: "drexel-university", country: "usa",
    name: "Drexel University", shortName: "Drexel", flag: "🇺🇸",
    city: "Philadelphia, Pennsylvania", founded: 1891, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top research university in Philadelphia renowned for its co-operative education model — the 'co-op' — where students alternate study terms with paid professional work experience. This makes Drexel graduates among the most job-ready in the U.S., with exceptional ties to Philadelphia's healthcare, engineering, and finance sectors.",
    tuition: { domestic: "$57,690/yr", international: "$57,690/yr" },
    living: "$1,500–$2,500/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — LeBow College of Business", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$75,000–$128,000", topEmployers: ["Comcast", "SAP", "Boeing", "Cigna", "GSK"] },
    intakes: ["September", "January"], istpStudents: 19,
  },

  "fordham-university": {
    slug: "fordham-university", country: "usa",
    name: "Fordham University", shortName: "Fordham", flag: "🇺🇸",
    city: "New York City, New York", founded: 1841, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1534430480872-3498386e7856?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "New York's Jesuit university — the 'Ivy of the Bronx.' Gabelli School of Business has unrivalled access to Wall Street and midtown Manhattan. Fordham Law School is a top-30 law school and the university's Lincoln Center campus is steps from Carnegie Hall.",
    tuition: { domestic: "$57,621/yr", international: "$57,621/yr" },
    living: "$2,200–$3,500/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Gabelli School of Business", duration: "2 years", language: "English" },
      { name: "JD — Fordham Law School", duration: "3 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Finance", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "$72,000–$125,000", topEmployers: ["JP Morgan", "Goldman Sachs", "Deloitte", "KPMG", "EY"] },
    intakes: ["August", "January"], istpStudents: 16,
  },

  "wake-forest-university": {
    slug: "wake-forest-university", country: "usa",
    name: "Wake Forest University", shortName: "Wake Forest", flag: "🇺🇸",
    city: "Winston-Salem, North Carolina", founded: 1834, qsRank: "#501 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top-30 national university known for its intimate size and teacher-scholar model. Babcock Graduate School of Management is well-regarded, and Wake Forest Law is consistently ranked among the top-40 law schools. The university excels in health sciences, business, and the liberal arts.",
    tuition: { domestic: "$63,210/yr", international: "$63,210/yr" },
    living: "$1,200–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Babcock School of Management", duration: "2 years", language: "English" },
      { name: "MS Finance", duration: "1 year", language: "English" },
      { name: "JD — School of Law", duration: "3 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$78,000–$130,000", topEmployers: ["Deloitte", "PwC", "Wells Fargo", "EY", "Bank of America"] },
    intakes: ["August"], istpStudents: 11,
  },

  "university-of-rochester": {
    slug: "university-of-rochester", country: "usa",
    name: "University of Rochester", shortName: "U of R", flag: "🇺🇸",
    city: "Rochester, New York", founded: 1850, qsRank: "#210 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top research university with one of the world's great music conservatories — Eastman School of Music — and a highly ranked medical center. Simon Business School is the smallest and most economically rigorous of any top-30 MBA program. Rochester excels in optics, data science, and brain sciences.",
    tuition: { domestic: "$62,860/yr", international: "$62,860/yr" },
    living: "$1,300–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Simon Business School", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MMus — Eastman School of Music", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$78,000–$132,000", topEmployers: ["Xerox", "Rochester Medical Center", "Deloitte", "Goldman Sachs", "Amazon"] },
    intakes: ["August", "January"], istpStudents: 14,
  },

  "case-western-reserve": {
    slug: "case-western-reserve", country: "usa",
    name: "Case Western Reserve University", shortName: "Case Western", flag: "🇺🇸",
    city: "Cleveland, Ohio", founded: 1826, qsRank: "#219 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A top research university in Cleveland's University Circle district — one of the densest concentrations of educational and medical institutions in the world. Case Western is exceptional in biomedical engineering, medicine, law, and management. The Weatherhead School of Management pioneered positive organizational scholarship.",
    tuition: { domestic: "$57,710/yr", international: "$57,710/yr" },
    living: "$1,200–$2,000/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Weatherhead School of Management", duration: "2 years", language: "English" },
      { name: "MS Biomedical Engineering", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "JD/MS Law — School of Law", duration: "3 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$78,000–$132,000", topEmployers: ["Cleveland Clinic", "Deloitte", "Amazon", "Parker Hannifin", "KeyBank"] },
    intakes: ["August", "January"], istpStudents: 13,
  },

  "rensselaer-polytechnic": {
    slug: "rensselaer-polytechnic", country: "usa",
    name: "Rensselaer Polytechnic Institute", shortName: "RPI", flag: "🇺🇸",
    city: "Troy, New York", founded: 1824, qsRank: "#351 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's oldest technological university — founded in 1824 — with exceptional programs in engineering, computer science, and architecture. RPI sits in the Capital Region of New York, close to Albany's semiconductor manufacturing cluster and a short drive to both Boston and New York City.",
    tuition: { domestic: "$59,766/yr", international: "$59,766/yr" },
    living: "$1,300–$2,100/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
      { name: "MBA — Lally School of Management", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "$80,000–$135,000", topEmployers: ["IBM", "GlobalFoundries", "Amazon", "Lockheed Martin", "GE"] },
    intakes: ["August", "January"], istpStudents: 15,
  },

  "colorado-school-of-mines": {
    slug: "colorado-school-of-mines", country: "usa",
    name: "Colorado School of Mines", shortName: "Mines", flag: "🇺🇸",
    city: "Golden, Colorado", founded: 1874, qsRank: "#351 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's leading university for earth resources engineering. The highest starting salaries for graduates of any public university in the U.S. Colorado Mines is world-class in petroleum engineering, mining engineering, materials science, and geophysics, with extraordinary placement in the energy and mining industries.",
    tuition: { domestic: "$18,810/yr", international: "$39,840/yr" },
    living: "$1,400–$2,200/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Petroleum Engineering", duration: "2 years", language: "English" },
      { name: "MS Mining Engineering", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "$85,000–$145,000", topEmployers: ["ExxonMobil", "Chevron", "Halliburton", "Schlumberger", "National Renewable Energy Lab"] },
    intakes: ["August", "January"], istpStudents: 13,
  },

  "virginia-tech": {
    slug: "virginia-tech", country: "usa",
    name: "Virginia Tech", shortName: "Virginia Tech", flag: "🇺🇸",
    city: "Blacksburg, Virginia", founded: 1872, qsRank: "#272 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Virginia's leading engineering university and one of the nation's top research institutions. Virginia Tech's programs in engineering, architecture, and computer science are nationally recognized. The Pamplin College of Business is AACSB-accredited, and the university is rapidly expanding its Northern Virginia footprint in Amazon's HQ2 corridor.",
    tuition: { domestic: "$14,468/yr", international: "$34,770/yr" },
    living: "$1,200–$1,900/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MBA — Pamplin College of Business", duration: "2 years", language: "English" },
      { name: "MS Electrical Engineering", duration: "2 years", language: "English" },
      { name: "MS Data Analytics & Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "$78,000–$132,000", topEmployers: ["Amazon", "Northrop Grumman", "Deloitte", "Leidos", "General Dynamics"] },
    intakes: ["August", "January"], istpStudents: 21,
  },

  "clemson-university": {
    slug: "clemson-university", country: "usa",
    name: "Clemson University", shortName: "Clemson", flag: "🇺🇸",
    city: "Clemson, South Carolina", founded: 1889, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of the South's premier public research universities and consistently among the top-25 public universities nationally. Clemson is exceptional in automotive engineering (with BMW's U.S. plant nearby), and has growing strengths in business, computer science, and sustainable design. The College of Business is AACSB-accredited.",
    tuition: { domestic: "$15,316/yr", international: "$37,832/yr" },
    living: "$1,100–$1,800/mo", ielts: "6.0+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — College of Business", duration: "2 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Automotive Engineering", duration: "2 years", language: "English" },
      { name: "MS Data Science & Analytics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$72,000–$120,000", topEmployers: ["BMW", "Michelin", "Amazon", "Deloitte", "Boeing"] },
    intakes: ["August", "January"], istpStudents: 16,
  },

  "university-of-georgia": {
    slug: "university-of-georgia", country: "usa",
    name: "University of Georgia", shortName: "UGA", flag: "🇺🇸",
    city: "Athens, Georgia", founded: 1785, qsRank: "#351 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "America's first state-chartered public university (1785) and one of the top-20 public universities nationally. The Terry College of Business is AACSB-accredited, and the UGA School of Law is a top-30 law school. Athens is one of the most charming and affordable college towns in the American South.",
    tuition: { domestic: "$11,818/yr", international: "$30,220/yr" },
    living: "$1,100–$1,800/mo", ielts: "6.0+", gre: "Required for most programs",
    topCourses: [
      { name: "MBA — Terry College of Business", duration: "2 years", language: "English" },
      { name: "JD — School of Law", duration: "3 years", language: "English" },
      { name: "MS Computer Science", duration: "2 years", language: "English" },
      { name: "MS Agricultural & Environmental Sciences", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "$70,000–$118,000", topEmployers: ["Deloitte", "Delta Air Lines", "EY", "Coca-Cola", "PwC"] },
    intakes: ["August", "January"], istpStudents: 18,
  },
};